export type RoomClashPeriodDto = {
  startTime: string;
  endTime: string;
}

export const getSlotsCount = (timeStr?: string): number => {
  if (!timeStr) return 0;

  const [hours, minutes] = timeStr.split(':').map(Number);

  return hours * 3 + Math.floor(minutes / 20);
};

export const calculatePeriodsLeft = (
  shiftLeft: number,
  clashedPeriods: RoomClashPeriodDto[]
): { shift: number; isClashed: boolean }[] => {
  const clashedPeriodsOnLeft = clashedPeriods
    .filter(period => {
      const periodStart = getSlotsCount(period.startTime);
      return periodStart <= shiftLeft;
    })
    .map(period => ({
      start: getSlotsCount(period.startTime),
      end: Math.min(getSlotsCount(period.endTime), shiftLeft)
    }))
    .sort((a, b) => a.start - b.start);

  const result = [];
  let currentPosition = 0;

  for (const clashedPeriod of clashedPeriodsOnLeft) {
    if (currentPosition < clashedPeriod.start) {
      result.push({
        shift: clashedPeriod.start - currentPosition,
        isClashed: false
      });
    }

    result.push({
      shift: clashedPeriod.end - Math.max(clashedPeriod.start, currentPosition),
      isClashed: true
    });

    currentPosition = Math.max(currentPosition, clashedPeriod.end);
  }

  if (currentPosition < shiftLeft) {
    result.push({
      shift: shiftLeft - currentPosition,
      isClashed: false
    });
  }

  return result.filter(item => item.shift > 0);
};

export const calculatePeriodsRight = (
  structureEndSlot: number,
  allDaySlotsCount: number,
  clashedPeriods: RoomClashPeriodDto[]
): { shift: number; isClashed: boolean }[] => {
  const clashedPeriodsOnRight = clashedPeriods
    .filter(period => {
      const periodEnd = getSlotsCount(period.endTime);
      return periodEnd > structureEndSlot;
    })
    .map(period => ({
      start: Math.max(getSlotsCount(period.startTime), structureEndSlot),
      end: getSlotsCount(period.endTime)
    }))
    .sort((a, b) => a.start - b.start);

  const result = [];
  let currentPosition = structureEndSlot;

  for (const clashedPeriod of clashedPeriodsOnRight) {
    if (currentPosition < clashedPeriod.start) {
      result.push({
        shift: clashedPeriod.start - currentPosition,
        isClashed: false
      });
    }

    result.push({
      shift: clashedPeriod.end - Math.max(clashedPeriod.start, currentPosition),
      isClashed: true
    });

    currentPosition = Math.max(currentPosition, clashedPeriod.end);
  }

  if (currentPosition < allDaySlotsCount) {
    result.push({
      shift: allDaySlotsCount - currentPosition,
      isClashed: false
    });
  }

  return result.filter(item => item.shift > 0);
};